export default __webpack_public_path__ + "static/media/bet-and-earn-banner.7f1a804f.webp";